import { colors } from "../../Styles";

export function Attention({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} style={{fillRule:"evenodd", clipRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "1.5"}} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
    <g transform="matrix(1.01262,0,0,1.01262,26.0483,-0.420875)">
        <circle cx="114.24" cy="206.76" r="13.24"/>
    </g>
    <g transform="matrix(0.940928,0,0,0.845415,8.37224,24.2194)">
        <path
          d="M124.726,106.19C124.726,106.19 129.463,131.08 131.688,153.476C133.347,170.183 133.327,185 133.327,185C133.327,190.161 137.092,194.352 141.73,194.352C146.368,194.352 150.133,190.161 150.133,185C150.133,185 150.113,170.183 151.772,153.476C153.997,131.08 158.734,106.19 158.734,106.19C158.734,95.744 151.115,87.264 141.73,87.264C132.345,87.264 124.726,95.744 124.726,106.19Z"
        />
    </g>
    <g transform="matrix(0.87451,0,0,0.886381,17.9869,15.4207)">
        <path
          d="M141.73,32L269,253L14,253L141.73,32Z"
          style={{ fill: "none", stroke: fillColor, strokeWidth: "20px" }}
        />
    </g>
    </svg>
  );
}